<template>
  <div>
    <activity-component
      :activity="activity"
      :description="description"
    />
  </div>
</template>

<script>
import { getUserData } from '@/auth/utils';
import ActivityComponent from './ActivityComponent.vue';

export default {
  components: {
    ActivityComponent,
  },
  props: {
    activity: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      self: getUserData(),
    }
  },
  computed: {
    description() {
      const { user, milestone, oldMilestone } = this.activity;
      const creator = user.uuid === this.self.uuid ? this.$t('You') : user.name;
      const action = oldMilestone ? 'changed' : 'attached';

      return `${creator} ${action === 'attached' ? `attached milestone <strong>"${milestone.name}"</strong> to this task` : `changed milestone from <strong>"${oldMilestone.name}"</strong> to <strong>"${milestone.name}"</strong>`}.`;
    },
  },
}
</script>
